import type { Member } from "../../shared/models";

/** Initial-in-a-circle in the member's color. */
export function Avatar({ member, size = "2rem" }: { member: Pick<Member, "displayName" | "color">; size?: string }) {
  const initial = member.displayName.trim().charAt(0).toUpperCase() || "?";
  return (
    <span className="avatar" style={{ ["--member" as string]: member.color, width: size, height: size }} title={member.displayName} aria-label={member.displayName}>
      {initial}
    </span>
  );
}
